var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionnaireReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2f42c2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2a1 1 0 0 0-1 1H6a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-2a1 1 0 0 0-1-1H9zm0 2h6v1H9V4zm9 2v14H6V6h2v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V6h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5l1.5 1.5 3-3 1 1-4 4-2.5-2.5 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11h3v1h-3v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5l1.5 1.5 3-3 1 1-4 4-2.5-2.5 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16h3v1h-3v-1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaireReportsIcon);
export default __webpack_public_path__ + "static/media/questionnaire_reports_icon.43dd1c76a031c7f0c09c4e93632bd61c.svg";
export { ForwardRef as ReactComponent };